import { GraphColor, LocalGraphColour } from "../Colors";

const api = process.env.REACT_APP_API_URL;

export const urls = {
	userCountries: `${api}GetUserCountries?`,
	quotaStatus: `${api}Approval/GetScenarioStatus`,
	periods: `${api}Approval/GetPeriods`,
	quotaForApproval: `${api}Approval/GetQuotaforApproval`,
	quotaCustomerBreakdown: `${api}Approval/GetQuotaCustomerBreakdown?`,
	approve: `${api}Approval/ApproveQuota`,
	approveQuotaWithComments : `${api}Approval/ApproveQuotaWithComments`,
	reject: `${api}Approval/RejectQuota`,
   popupGraphData: `${api}ApprovalQuotaModification/GetPopUpGraphData?`,
   popupGraphDataBySku: `${api}ApprovalQuotaModification/GetPopUpGraphDataBySKU`,
   lockUnlockQuota: `${api}Approval/LockUnlockQuota`,
   approveMultiple: `${api}Approval/ApproveQuotaMultiple`,
   lockUnlockMultiple: `${api}Approval/LockUnlockQuotaMultiple`,
   rejectMultiple: `${api}Approval/RejectQuotaMultiple`,
   approveMulWithComment: `${api}Approval/ApproveQuotaWithCommentsMultiple`,
   Downloadfile: `${api}Define/DownloadFile?`,
   Upload : `${api}Approve/Upload`,
};

export function getQuotaForApprovalTable(data) {
	const rows = getQuotaForApprovalRow(data);
	for(let i = 0; i < rows.length; i++) {
		rows[i] = getApproveStatus(rows[i]);
	}
	return { rows };
}

function getQuotaForApprovalRow(data) {
	const rows = data.map((item, index) => {
		return {
			id: index,
			quotaId: item.quotaId,
         	scenarioId: item.scenarioId,
			scenarioName: item.scenarioName,
			geoId: item.geoId,
			criticalityId: item.criticalityId,
			graph: item.graph,
			quotaStatus: item.quotaStatus,
			initialForecast: item.initialForecast,
			totalForecast: item.totalForecast,
			previousTotalForecast: item.previousTotalForecast,
			difference: item.difference,
			depletion: item.depletion,
			previousDepletion: item.previousDepletion,
			lastActionDate: item.lastActionDate,
			lastActionBy: item.lastActionBy,
			period: item.period,
			rejectComments: item.rejectComments,
			approveComments: item.approveComments,
			isSubmitLocked: item.isSubmitLocked,
			edit: item.scenarioName,
			revisedQuota: item.revisedQuota,
		};
	});
	return rows;
}

export function getQuotaDetailsTable(data) {
	const columns = getQuotaDetailsColumn();
	const rows = getQuotaDetailsRow(data);
	return { columns, rows };
}

function getQuotaDetailsColumn() {
	const width = 150;
	const columns = [
		{ field: "customerName", headerName: "Customer / CG", width: width },
		{ field: "customerNumber", headerName: "Customer Number", width: width },
		{ field: "skuName", headerName: "SKU / PG", width: width },
		{ field: "skuNumb", headerName: "SKU Number", width: width },
		{ field: "initialQuota", headerName: "Initial Quota", width: width },
		{ field: "safetyMargin", headerName: "Safety Margin", width: width },
		{ field: "adjustment", headerName: "Adjustment", width: width },
		{ field: "totalQuota", headerName: "Total Quota", width: width },
		{ field: "weekly1", headerName: "Week 1", width: width },
		{ field: "weekly2", headerName: "Week 2", width: width },
		{ field: "weekly3", headerName: "Week 3", width: width },
		{ field: "weekly4", headerName: "Week 4", width: width },
		{ field: "weekly5", headerName: "Week 5", width: width },
		{
			field: "customerQuotaComments",
			headerName: "Customer Quota Comments",
			width: width,
		},
	];
	return columns;
}

function getQuotaDetailsRow(data) {
	const rows = data.map((item, index) => {
		return {
			id: index,
			customerName: item.customerName,
			customerNumber: item.customerNumber,
			skuName: item.skuName,
			skuNumb: item.skuNumb,
			initialQuota: item.initialQuota,
			safetyMargin: item.safetyMargin,
			adjustment: item.adjustment,
			totalQuota: item.totalQuota,
			weekly1: item.weekly1,
			weekly2: item.weekly2,
			weekly3: item.weekly3,
			weekly4: item.weekly4,
			weekly5: item.weekly5,
			customerQuotaComments: item.customerQuotaComments,
		};
	});
	return rows;
}
function  getApproveStatus (item){
	let quotaStatus = item.quotaStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
	}
	else {
		if (quotaStatus == "approved" || quotaStatus == "rejected" || quotaStatus == "draft") {
		item['canApproveReject'] = false;
		}
		else {
		if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
			if (quotaStatus == "submitted" || quotaStatus == "locally approved") {
			item['canApproveReject'] = true;
			}
		}
		else if (!logedUser.isHQUser) {
			if (quotaStatus == "submitted") {
			item['canApproveReject'] = true;
			}
			else if (quotaStatus == "locally approved") {
			item['canApproveReject'] = false;
			}
		}
		}
	}
	return item;
  }

export function preparePopupGraphData(data) {
	if (!Array.isArray(data) || data.length === 0) {
		return { periods: [], seriesData: [], color: [] };
	}

	// API may return rows grouped by period (all sources for Sep, then all for Oct, …)
	// or legacy blocks of N periods per source. Build unique x-axis categories and pivot
	// one series per data source.
	const periodOrder = [];
	const seenPeriod = new Set();
	for (const item of data) {
		const p = item?.period;
		if (p == null || p === "") continue;
		if (!seenPeriod.has(p)) {
			seenPeriod.add(p);
			periodOrder.push(p);
		}
	}

	const sourceOrder = [];
	const seenSourceKey = new Set();
	for (const item of data) {
		const key = `${item?.datasourceID}__${item?.dataSourceName ?? ""}`;
		if (seenSourceKey.has(key)) continue;
		seenSourceKey.add(key);
		sourceOrder.push({
			datasourceID: item.datasourceID,
			dataSourceName: item.dataSourceName,
		});
	}

	const lookup = new Map();
	for (const item of data) {
		const p = item?.period;
		if (p == null || p === "") continue;
		const sourceKey = `${item?.datasourceID}__${item?.dataSourceName ?? ""}`;
		if (!lookup.has(p)) {
			lookup.set(p, new Map());
		}
		lookup.get(p).set(sourceKey, item.value);
	}

	function normalizeValue(raw) {
		let s = raw;
		if (s === "null") {
			s = null;
		} else if (s === 0) {
			s = null;
		}
		return s;
	}

	const seriesData = sourceOrder.map((src) => {
		const sourceKey = `${src.datasourceID}__${src.dataSourceName ?? ""}`;
		const values = periodOrder.map((period) => {
			const periodMap = lookup.get(period);
			const raw = periodMap?.get(sourceKey);
			return normalizeValue(raw);
		});
		return { name: src.dataSourceName, data: values };
	});

	const color = [];
	for (let i = 0; i < sourceOrder.length; ++i) {
		const dsr = sourceOrder[i];
		if (dsr.dataSourceName?.toLowerCase().includes("ex-factory")) {
			color.push(GraphColor["Ex-Factory"]);
		} else if (dsr.dataSourceName?.toLowerCase().includes("iqvia - midas")) {
			color.push(GraphColor["IQVIA - MIDAS"]);
		} else if (dsr.dataSourceName?.toLowerCase().includes("forecast")) {
			color.push(GraphColor.Forecast);
		} else if (dsr.dataSourceName?.toLowerCase().includes("modified quota")) {
			color.push(GraphColor["Modified Quota"]);
		} else if (dsr.dataSourceName?.toLowerCase().includes("quota")) {
			color.push(GraphColor.Quota);
		} else if (dsr.dataSourceName?.toLowerCase().includes("sit")) {
			color.push(GraphColor.SIT);
		}else if (dsr.dataSourceName?.toLowerCase().includes("deliveredqty")) {
			color.push(GraphColor["DeliveredQTY"]);
		} else if (dsr.datasourceID > 5 && dsr.datasourceID < 50) {
			color.push(LocalGraphColour[dsr.datasourceID]);
		} else {
			color.push("#16d620");
		}
	}

	const graphData = { periods: periodOrder, seriesData, color };
	console.log("Approval_Quota_preparePopupGraphData", graphData);
	return graphData;
}
